import { defineComponent as _defineComponent } from 'vue'
import KetchUpButton from '@/components/common/KetchUpButton.vue'
  import { useRouter } from 'vue-router/composables'
  import useCommonMixin from '@/composables/useCommonMixin'
  import useCourse from '@/composables/useCourse'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'CourseExamTimeoutModal',
  setup(__props) {

  const { isKnowledgeCheckCompany, closeModal } = useCommonMixin()
  const { latestExamCompletionId } = useCourse()
  const router = useRouter()

  const toStartPage = () => {
    router.push({ name: isKnowledgeCheckCompany.value ? 'KnowledgeCheckInfo' : 'ExamStartPage' }).catch(() => {
      return
    })
    closeModal()
  }

  const toExamResultsPage = () => {
    router.push({ name: 'CourseExamResults', params: { completionId: latestExamCompletionId.value! } }).catch(() => {
      return
    })
    closeModal()
  }

return { __sfc: true,isKnowledgeCheckCompany, closeModal, latestExamCompletionId, router, toStartPage, toExamResultsPage, KetchUpButton, useRouter, useCommonMixin, useCourse }
}

})